import type { SelectOption } from "@/components/input-select/InputSelect";
import { literals } from "./literals";

export const GARAGE_STEPS = [
  { label: literals.garageEnter, value: literals.garageEnter },
  { label: literals.findings, value: literals.findings },
  { label: literals.garageExit, value: literals.garageExit },
];

export const GARAGES = [
  {
    value: "MT000225",
    label: "MT000225",
  },
  {
    value: "MT000226",
    label: "MT000226",
  },
  {
    value: "MT000229",
    label: "MT000229",
  },
  {
    value: "TGFRE000",
    label: "TGFRE000",
  },
  {
    value: "TGQEC000",
    label: "TGQEC000",
  },
  {
    value: "TGRUE000",
    label: "TGRUE000",
  },
  {
    value: "TGSAM000",
    label: "TGSAM000",
  },
  {
    value: "TIHYD208",
    label: "TIHYD208",
  },
  {
    value: "TINEU209",
    label: "TINEU209",
  },
  {
    value: "TIATE105",
    label: "TIATE105",
  },
];

export const PUESTO_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  {
    label: literals.noServCell,
    value: literals.noServCell,
  },
  ...GARAGES,
  {
    label: literals.exits,
    value: literals.exits,
  },
];

export const PASO_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  { label: literals.inNoServ, value: literals.inNoServ },
  { label: literals.outNoServ, value: literals.outNoServ },
  { label: literals.garageEnter, value: literals.garageEnter },
  { label: literals.findings, value: literals.findings },
  { label: literals.garageExit, value: literals.garageExit },
  { label: literals.packagingAction, value: literals.packagingAction },
  { label: literals.presendsAction, value: literals.presendsAction },
  { label: literals.outNoServ, value: literals.outNoServ },
];

export const PASO_GARAGE_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  ...GARAGE_STEPS,
];

export const NO_SERV_STEPS: SelectOption[] = [
  { label: literals.inNoServ, value: literals.inNoServ },
  { label: literals.outNoServ, value: literals.outNoServ },
];

export const PASO_NOSERV_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  ...NO_SERV_STEPS,
];

export const EXITS_STEPS: SelectOption[] = [
  { label: literals.packagingAction, value: literals.packagingAction },
  { label: literals.presendsAction, value: literals.presendsAction },
];

export const PASO_EXITS_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  ...EXITS_STEPS,
];

export const VISIBLE_CLIENTE_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  { label: literals.yes, value: "true" },
  { label: literals.no, value: "false" },
];

export const EMBALAJE_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  { label: literals.yes, value: "true" },
  { label: literals.no, value: "false" },
];

export const CAPTURE_DESCRIPTION_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  { label: literals.packaging, value: literals.packaging },
  { label: literals.generalOverview, value: literals.generalOverview },
  { label: literals.idLabel, value: literals.idLabel },
  { label: literals.mishandling, value: literals.mishandling },
  { label: literals.misuse, value: literals.misuse },
  { label: literals.others, value: literals.others },
];

export const PACKAGING_STEP_DESCRIPTION_OPTIONS: SelectOption[] = [
  {
    label: literals.selectOption,
    value: "",
  },
  { label: "ID Plate", value: "ID Plate" },
  { label: "Pieza antes embalar", value: "Pieza antes embalar" },
  { label: "Pieza embalada", value: "Pieza embalada" },
  { label: "Embalaje cerrado", value: "Embalaje cerrado" },
];
